<template>
    <div class="protociol_page">
        <div v-if="type==1">
            <h1 class="title">知情同意书</h1>
            <div>
                <div class="content">尊敬的用户：</div>
                <div class="content"  v-for="(item,index) in dataList2" :key="index">
                    <div style="text-indent:26px;">{{item.content}}</div>
                    <div v-html="item.content2" style="text-indent:26px;"></div>
                </div>
                <div style="font-weight:bold; text-align:justify">您确认已了解上述告知内容、知悉相关风险，并同意进行线上复诊。</div>
                <div style="font-weight:bold; text-align:right;margin-top:20px;">莲藕互联网医院</div>
            </div>
        </div>
        <div v-if="type==2">
            <h1 class="title">莲藕互联网医疗服务知情同意协议书</h1>
            <div class="list"> 
                <div class="item" v-for="item in dataList" :key="item.title">
                <div class="title2">{{item.title}}</div>
                <div class="content"  v-for="items in item.list" :key="items">
                    {{items}}
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            type:0,
            dataList:[
                {
                    title:"一、服务简介",
                    list:[
                            "1.1 用户点击同意本协议，即视为用户确认自己具有享受本客户端服务、下单购买等相应的权利能力和行为能力并同意和知晓了本协议全部告知事项，能够独立承担法律责任。限制行为能力人和无民事行为能力人，需要在监护人的监护参与下才能使用本客户端。",
                            "1.2 为了帮您建立有效的病历档案，方便医生或医生团队准确掌握您的情况以便于更好地为您服务，本次服务前，请准确输入您真实的手机号码、身份证号码、姓名、年龄、性别、地址等个人资料并对您所填资料的真实性承担责任。",
                            "1.3 用户不得将在本站注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，实际使用人承担连带责任。",
                            "1.4 医生团队由医生和医生助理组成，医生对其医生助理的医疗知识和医疗行为负责管理，授权和审查。",
                    ]
                },
                {
                    title:"二、服务内容",
                    list:[
                            "2.1 互联网医院的网上诊疗行为由医生或医生团队提供，开具处方需具有职业医师资格医师及药师电子签名，药师审核处方的合理用药，处方当天有效。",
                            "2.2 为了我们能更有效和全面地了解您的病请，请您在就诊前务必填写您的病情或提供并上传既往病历、检查报告、生命体征检测结果等资料。生命体征可在所在药店进行检测，包括：血压、体温、脉搏、呼吸频率、身高、体重等。",
                            "2.3 在接受远程医疗服务过程中，请您真实回答医生提出的问题，切勿故意隐瞒或虚报。由此造成的不良后果，一切由您本人负责。",
                            "2.4 互联网门诊服务慢性病、常见病多发病等复诊患者，不接受初治患者或未明确诊断、疑难病、罕见病等疾病，或者远程医疗不能解决的复杂问题，此类情况建议您去其他医疗机构接受进一步诊治。",
                            "2.5 您是否有药物过敏史，若有您需提前填写清楚，或告知医生或医生团队，同时用药过程中如有不适反应要及时告知医生或医生团队。任何药物都有毒副作用，无论通过口服、注射、外用等任何给药途径，对人体都有毒害作用，正常合理用药也可以引起不良反应，包括但不限于：头晕、头痛、发热、口干、哮喘、乏力嗜睡、排尿困难、皮疹、胃肠反应、消化道出血穿孔、血细胞减少、凝血功能障碍出血、再生障碍性贫血、过敏性肺炎、继发性感染、肝肾功损害、神经损害、心率失常、心衰、过敏性休克等甚至危及生命。抗菌药物及毒麻药物，如需使用，将对您做特殊的告知。 您需清楚该药物的功能，若不清楚需提前告知医生或医生团队。",
                            "2.6 怀孕及哺乳期妇女、14岁及以下儿童、65岁以上老年患者需在专科指导下用药。服用药物过程中如出现不适，及时到当地医院就诊。"
                    ]
                },
                {
                    title:"三、使用权责",
                    list:[
                            "3.1 遵守中国有关的法律和法规；",
                            "3.2 不得为任何非法目的而使用互联网医院服务系统；",
                            "3.3 遵守所有与互联网医院服务有关的网络协议、规定和程序；",
                            "3.4 不得利用互联网医院服务系统进行任何可能对互联网的正常运转造成不利影响的行为；",
                            "3.5 不得利用互联网医院服务系统进行任何不利于医院的行为；",
                            "3.6 如发现非法使用用户帐号或帐号出现安全漏洞的情况，应立即通告互联网医院系统管理员或者客服人员。",
                            "3.7 用户自行更改医生处方药品药量出现的安全问题由用户自行承担。",
                    ],
                    tip:"广东莲藕健康科技有限公司负责互联网医院平台正常运行，用户在使用互联网医院相关服务过程中，必须遵循以下原则："
                },
                {
                    title:"四、隐私保护",
                    list:[
                            "4.1 用户在本客户端进行购买活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，本站将予以严格保密，除非得到用户的授权或法律另有规定，本站不会向外界披露用户隐私信息。用户同意，互联网医院拥有通过邮件、微信、短信、电话等形式，向在本客户端注册、购买的用户发送订单信息、促销活动等告知信息的权利。用户不得将在本站注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。",
                            "4.2 保护用户隐私是互联网医院的一项基本政策，互联网医院保证不对外公开或向第三方提供用户注册资料及用户在使用互联网医院相关服务时存储的非公开内容，但下列情况除外：",
                            "(a) 事先获得用户的明确授权； ",
                            "(b) 根据有关的法律法规要求；",
                            "(c) 按照相关政府主管部门的要求；"
                    ],
                    
                },
                {
                    title:"五、回访",
                    list:["我们可能会在您就诊后的3天~1月内，就治疗效果、满意度、远程就诊遇到的困难等问题进行电话、微信、邮件，短信等随访和跟踪。请对我们的服务提出宝贵建议。"]
                    
                },
                {
                    title:"六、用药告知",
                    list:[
                        "根据您的用药请求，虽然您已经说明您服用过，为二次购买，我们拟为您开具相应用药处方，鉴于药品的特殊性和药品的毒副作用及不良反应等诸多风险的存在，我们现将有关用药的风险进行以下说明，请您在向用户推荐，用户购买之前，店员，用户务必仔细阅读，因为我们是互联网医疗，无法判断您所购买药品是否与上次的一样，药品的真假，有效期，存储，销售过程，用户购买后的存储过程，生产过程，生产批号，运输过程，药品成分等等的安全性，不同批号也可能导致用药风险和不可预知的后果，建议您到原用药地购买同样的处方药，我们已经在本协议中向您（店员和用户）解释，您务必遵守用药禁忌，否则后果自负，如果出现任何不良后果，我们将免责；我们对非本人问诊，出现的任何风险，我们免责；对没有执业药师审核直接发药的处方不承担责任；我们不能对您本次处方用药承担责任，但我们已经严格按照国家相关法律法规执行，遵守相关规定，将用药的风险提醒您并争取降到最低；如有任何不明之处，敬请及时提出，我们给出的处方，当地药师务必审核其合理性：",
                        "抗生素类药品：存在风险，可能会发生过敏反应，常见的副作用有肝毒性、肾毒性、胃肠道反应、个别药物有耳毒性，严重时会导致过敏性休克；服用抗生素期间注意事项：",
                        "1.确定有细菌感染才用抗生素； ",
                        "2.针对性用药才有效果； ",
                        "3.不随便联合用药； ",
                        "4.不预防用药； ",
                        "5.要足量足疗程用药； ",
                        "6.儿童、孕妇、哺乳期妇女使用抗生素要遵医嘱并且要仔细阅读药品说明书； ",
                        "7.提醒（如果已经服用酒精，一周内不能服用该药等等），服用药物过程中，出现不适紧急到当地医院就诊。",
                        "精神类：精类药物在使用时会导致：1.嗜睡、头晕；2.精神异常；3.二便异常；4.椎体外系反应。使用时要遵医嘱服药，仔细阅读说明书，并且要保管好药物。定期到当地医院监测病情。服用药物过程中，出现不适紧急到当地医院就诊。",
                        "毒麻类：毒麻类药物会导致：胃肠道反应、呼吸道反应甚至呼吸抑制、神经系统反应、成瘾等。毒麻类药物要遵医嘱合理使用，要了解药物特性，保管好药物。定期到当地医院复诊。服用药物过程中，出现不适紧急到当地医院就诊。",
                        "喝酒后这几类药物需注意： ",
                        "1.降血压类药物：会使血压降的更低造成危险； ",
                        "2.降血糖类药物：会使血糖降的更低造成危险； ",
                        "3.阿司匹林等水杨酸类药物，会导致胃出血风险；",
                        "4.头孢类抗菌药物：会导致双硫仑反应； ",
                        "5.巴比妥类药物和抗抑郁类药物：会导致中枢抑制。",
                        "驾驶员或高空作业的人群使用药物注意： ",
                        "1.引起椎体外系反应的药物：苯海拉明、氟哌啶醇等可引起椎体外系反应，可导致运动失调，协调动作障碍。 ",
                        "2.含有镇静和抗过敏成分的药物：如扑尔敏、安定、白加黑、速效伤风胶囊等可引起嗜睡、头痛头晕。 ",
                        "3.影响视力和听力的药物。",
                        "老人儿童需要严格遵照医嘱服药，不能自理的老人和儿童要在成人的监护下使用。服用药物过程中，出现不适紧急到当地医院就诊。",
                        "孕妇、哺乳期妇女用药要严格遵照妇产科医师医嘱，并仔细阅读药品说明书。服用药物过程中，出现不适紧急到当地医院就诊。",
                        "因以上诸多原因，所以特别提醒，为方便大家，销售药品的店员和购买药品的用户承诺该药来源合法，药师对我们提供处方负责审核并自愿承担使用该药的后果，双方签署本协议，按同意键后，本医疗机构开具用药处方；如因药品，或服用药品人本人因素（如过敏性体质、不尊医嘱等）问题出现不良反应，我们免责。",
                        "本《莲藕互联网医疗服务知情同意协议书》是本平台与店员及问诊用户在平等自愿的原则下签订的，本平台和莲藕互联网医疗机构已将在处方用药中可能出现的风险全部告知了药品销售店员及问诊用户，已尽到告知义务。",
                        "",
                    ]
                    
                },



            ],
            dataList2:[
                {
                    content:"接受互联网诊疗可能出现以下潜在风险（有些不常见的风险未能一一列出，如果患者有疑问应与医生讨论）：",
                    content2:""
                },
                {
                    content:"受限于互联网诊疗本身的局限性（如远程咨询医师无法直接进行体格检查、检验或医疗仪器设备辅助诊断，不能面诊、触诊等，也无法通过相关的诊查手段及检查、检验结果准确判断病情的逬展），医生给出的本次诊疗方案、健康管理方案、远程医疗方案依赖于患者的描述及具上传的资料，以及既往的病历资料、临床诊断。如前述信息不准确或不全面，将对本次诊疗方案的合理制定产生一定的影响。",
                    content2:""
                },
                {
                    content:"由于疾病本身的特殊性和复杂性，患者本身的体质状况，及现有医疗水平条件的限制等，存在发生各种并发症和危害自身生命健康的意外风险的可能。由于疾病本身的复杂性，以及诊疗措施疗效出现的延后性，远程医疗方案可能不会达到患者期待的效果，且有些疾病或并发症是不可根治的，需要患者积极配合，长期坚持治疗，才能延缓疾病的进展。医生已经尽力为患者制定合理的方案，致力减少药物治疗不良反应的发生，但不可能完全避免，且不可预测，需要在患者的配合下，并根据临床情况不断调整方案。",
                    content2:""
                },
                {
                    content:"疾病的治愈需要患者谨遵医嘱、健康管理方案，并积极配合。如果患者未完全遵守和配合，则可能导致诊疗效果不理想，甚至出现病情反复、恶化等不良后果。",
                    content2:""
                },
                {
                    content:"在问诊开处方药之前，请再次明确：",
                    content2:""
                },
                {
                    content:"",
                    content2:"1.<span style='color:red'>您保证就诊的人为您本人</span>而且问诊过程中您的病史、医疗文书、辅助检查<span>均在正规医院就诊而且真实有效，并已对医生的问诊如实回答</span>。"
                },
                {
                    content:"",
                    content2:"2.您需了解若您是过敏体质人群或正在服用其他药品，<span style='color:red'>服药前必须先咨询线下医生或药师意见。</span>"
                },
                {
                    content:"",
                    content2:"3.<span style='color:red'>使用药物前，请详细阅读药物说明书（需着重了解药品用法、用量，使用禁忌和相关注意事项，如为禁忌人群请勿使用），并严格按照使用说明使用</span>。"
                },
                {
                    content:"",
                    content2:"4.您需要了解药物均具一定副作用，药物均经肝脏或肾脏代谢，有些还会对血液系统有一定的影响。<span style='color:red'>服药后建议您定期复查血常规及肝肾功</span>，以4-6周为宜。"
                },
                {
                    content:"",
                    content2:"5.在药物治疗过程中，几乎所有的药物都可引起不良反应，只是反应的程度和发生率不同。常见的药物不良反应例如：口干、视觉模糊、皮炎皮疹、皮肤瘙痒、血管神经水肿，呼吸加快、 恶心 呕吐 头痛等症状。<span style='color:red'>若您在用药过程中出现任何不良反应或疗效不佳时，建议您应立即停药，并到医院就诊，听取医生的诊断意见</span>。"
                },
                {
                    content:"",
                    content2:"6.<span style='color:red'>服用处方药物，请您定期到线下医院复诊复查，看您所用的药物方案是否需要调整</span>（如高血压及糖尿病的患者一定定期监测血压、血糖指标，不能盲目按既有方案服用。）"
                }
            ]
        }
    },
    mounted(){
        this.type = this.$route.query.type
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    }
}
</script>
<style lang="scss" scoped>
    .protociol_page{
        padding: 0 20px;
        font-size: 13px;
        text-align: left;
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
        .item{
            margin-bottom: 30px;
        }
        
        .title{
            margin-bottom: 20px;
            font-size: 20px;
            
        }
        .title2{
            text-align:left;
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 10px;
        }
        .content{
            text-align: justify;
            margin-bottom: 12px;
        }
    }
</style>